// extracted by mini-css-extract-plugin
module.exports = {"avatar_placeholder":"AvatarPlaceholder_avatar_placeholder__3IDA3","small_placeholder":"AvatarPlaceholder_small_placeholder__333zB"};